import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function TripppSparkPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-707">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-708">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40" data-id="element-709">
          <div className="absolute top-10 left-10 w-64 h-96 bg-gradient-to-br from-[#FF3CAC]/20 to-transparent rounded-2xl blur-xl transform -rotate-12" data-id="element-710"></div>
          <div className="absolute top-40 right-20 w-80 h-[500px] bg-gradient-to-bl from-[#7B2FFF]/20 to-transparent rounded-2xl blur-xl transform rotate-6" data-id="element-711"></div>
          <div className="absolute bottom-10 left-1/3 w-72 h-80 bg-gradient-to-t from-[#00E5FF]/20 to-transparent rounded-2xl blur-xl" data-id="element-712"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-713">
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-714">
            <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-715">
              {t('tripppSpark.badge')}
            </span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-716">
            {t('tripppSpark.heroTitle')}
            <span className="text-gradient" data-id="element-717">
              {t('tripppSpark.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-718">
            {t('tripppSpark.heroDesc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-719">
            <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="bg-gradient-animated rounded-full px-8 py-4 text-base font-semibold text-white text-center hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(255,60,172,0.3)]" data-id="element-720">
              {t('tripppSpark.bookDemo')}
            </a>
            <button type="button" className="rounded-full border border-white/20 px-8 py-4 text-base font-semibold text-white text-center hover:border-transparent hover:bg-white/5 transition-all duration-300 relative group overflow-hidden" data-id="element-721">
              <div className="absolute inset-0 bg-gradient-animated opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
              padding: '1px',
              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude'
            }} data-id="element-722"></div>
              <span className="relative z-10" data-id="element-723">
                {t('tripppSpark.experienceItLive')}
              </span>
            </button>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-724">
        <div className="max-w-7xl mx-auto px-6" data-id="element-725">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-726">
            {t('tripppSpark.howItWorksTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-727">
            <div className="hidden md:block absolute top-6 left-[15%] right-[15%] h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-728"></div>
            {[0, 1, 2].map(idx => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-729">
                <div className="w-12 h-12 rounded-full bg-[#050505] border border-white/20 flex items-center justify-center mb-6 text-gradient font-bold text-xl" data-id="element-730">
                  {idx + 1}
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-731">
                  {t(`tripppSpark.step${idx}Title`)}
                </h3>
                <p className="text-white/60 leading-relaxed" data-id="element-732">
                  {t(`tripppSpark.step${idx}Desc`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-733">
        <div className="max-w-7xl mx-auto px-6" data-id="element-734">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-735">
            {t('tripppSpark.targetsTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-736">
            {[0, 1, 2].map(idx => <div key={idx} className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-colors" data-id="element-737">
                <h3 className="text-xl font-bold mb-4 text-gradient" data-id="element-738">
                  {t(`tripppSpark.target${idx}Title`)}
                </h3>
                <p className="text-white/60 leading-relaxed" data-id="element-739">
                  {t(`tripppSpark.target${idx}Desc`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-740">
        <div className="max-w-7xl mx-auto px-6" data-id="element-741">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-742">
            {t('tripppSpark.deploymentTitle')}
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-743">
            <div className="group relative rounded-3xl overflow-hidden bg-[#050505] min-h-[300px]" data-id="element-744">
              <div className="absolute inset-0 border border-white/10 rounded-3xl group-hover:opacity-0 transition-opacity duration-300" data-id="element-745"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-gradient-animated rounded-3xl" data-id="element-746"></div>
              <div className="relative h-full p-10 flex flex-col justify-end z-10" data-id="element-747">
                <h3 className="text-3xl font-bold mb-4 text-white" data-id="element-748">
                  {t('tripppSpark.deployment0Title')}
                </h3>
                <p className="text-white/60 text-lg leading-relaxed mb-8" data-id="element-749">
                  {t('tripppSpark.deployment0Desc')}
                </p>
                <button type="button" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300" data-id="element-750">
                  {t('tripppSpark.experienceIt')}{' '}
                  <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-751" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-752">
        <div className="max-w-4xl mx-auto px-6" data-id="element-753">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-754">
            {t('tripppSpark.differentTitle')}
          </h2>
          <div className="space-y-8" data-id="element-755">
            {[0, 1, 2, 3].map(idx => <div key={idx} className="flex items-center p-6 bg-[#0A0A0A] rounded-2xl border border-white/5" data-id="element-756">
                <div className="w-1.5 h-12 rounded-full bg-gradient-animated mr-6 shrink-0" data-id="element-757"></div>
                <p className="text-xl text-white/90 font-medium" data-id="element-758">
                  {t(`tripppSpark.diff${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#0A0A0A] border-t border-white/5" data-id="element-759">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-760">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-761"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-762"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-763">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-764">
            {t('tripppSpark.ctaTitle')}
            <span className="text-gradient" data-id="element-765">
              {t('tripppSpark.ctaHighlight')}
            </span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-766">
            {t('tripppSpark.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}